"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApolloErrorMessage = void 0;
var react_1 = __importStar(require("react"));
var Button_1 = __importDefault(require("@components/Button"));
function ApolloErrorMessage(_a) {
    var refetchData = _a.refetchData, error = _a.error, title = _a.title, tryAgainText = _a.tryAgainText, customButton = _a.customButton;
    var errorDetailMessage = (0, react_1.useMemo)(function () {
        if (error && typeof error === 'object' && 'data' in error) {
            return error.data.message;
        }
    }, [error]);
    return (react_1.default.createElement(react_1.default.Fragment, null, error ? (react_1.default.createElement("div", { className: "lead has-error" },
        react_1.default.createElement("h2", null, title),
        react_1.default.createElement("div", null, errorDetailMessage),
        customButton || react_1.default.createElement(Button_1.default, { onClick: refetchData, text: tryAgainText }))) : null));
}
exports.ApolloErrorMessage = ApolloErrorMessage;
